export const refreshTokenUri = '/oauth/token'